import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors } from '~styles/theme.stylex';
export const styles = {
  panel: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    width: "xh8yej3",
    $$css: true
  },
  providers: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x1qjc9v5",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  divider: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    color: "xarw3lm",
    fontSize: "x1dcheo9",
    "::before_content": "x1cpjm7i",
    "::before_flexGrow": "x10bxx3s",
    "::before_borderTopWidth": "xm4vf9w",
    "::before_borderTopStyle": "xnvurfn",
    "::before_borderTopColor": "xthw1yq",
    "::after_content": "x1s928wv",
    "::after_flexGrow": "x71tlqn",
    "::after_borderTopWidth": "xoiy6we",
    "::after_borderTopStyle": "xynf4tj",
    "::after_borderTopColor": "x1m6yw9b",
    $$css: true
  },
  dividerLabel: {
    flexShrink: "x2lah0s",
    $$css: true
  },
  error: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    color: "x5d2zeg",
    fontSize: "x1dcheo9",
    lineHeight: "x1evy7pa",
    $$css: true
  }
};